export const enterContest = async ({ token, contestId, userId, contestType, direction, wager }: {token: string, contestId: string, userId: string, contestType: string, direction: string, wager: number}) => {
  const apiToken = "api token";
  const contentJSON = JSON.stringify({
      contestId: "",
      userId: "",
      contestType: "",
      direction: "",
      wager:""
  });
  try {
    const response = await fetch(`${process.env.REACT_APP_URL_HXROAPI}/contestentry/add-contest-entry`, {
      method: 'post',
      headers: {
        'Content-Type':'application/json',
        'Ocp-Apim-Subscription-Key': apiToken,
        'Content-Length': `${contentJSON.length}`,
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        contestType,
        direction,
        contestId,
        userId,
        wager,
      })
    });

    const data = await response.json();

    return data;

  } catch(error) {
    console.log(error)
    return false;
  };
};